import { Component, HostListener, OnInit, inject } from '@angular/core';

import { BuildInfoService, PromotionalDialogService } from '../../services';
// Libs
import { UiModule } from '../../ui.module';
import { PromotionalDialogComponent } from './../../components/promotional-dialog/promotional-dialog.component';

@Component({
  standalone: true,
  imports: [UiModule, PromotionalDialogComponent],
  template: `
    <phoenix-sidenav></phoenix-sidenav>

    <phoenix-promotional-dialog></phoenix-promotional-dialog>
  `,
})
export class MainComponent implements OnInit {
  promotionalDialogService = inject(PromotionalDialogService);
  buildInfoService = inject(BuildInfoService);

  ngOnInit(): void {
    this.buildInfoService.checkBuildInfo();
  }

  //Check if a new version of Phoenix is available
  @HostListener('document:visibilitychange')
  visibilityChange() {
    if (document.hidden) {
      this.buildInfoService.stopCheckTimer();
    } else {
      this.buildInfoService.checkBuildInfo();
    }
  }
}
